// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';


// Third party modules
import { DataTablesModule } from 'angular-datatables';

// Pipes
import { SharedPipesModule } from '../../../shared/shared-pipes/shared-pipes.module';


import { SharedUsersRoutingModule } from './shared-users-routing.module';
import { SharedUserListComponent } from './shared-user-list/shared-user-list.component';
import { SharedUserDisplayComponent } from './shared-user-display/shared-user-display.component';

@NgModule({
    declarations: [SharedUserListComponent, SharedUserDisplayComponent],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        DataTablesModule,
        SharedUsersRoutingModule,
        SharedPipesModule
    ],
    exports: [SharedUserListComponent, SharedUserDisplayComponent],
})
export class SharedUsersModule { }
